<template>
  <div>
    <div v-if="!accessToken" class="login" @click.stop="loginIn()">
      {{ $t("loginIn") }} 
    </div>
    <div v-if="accessToken" class="login">
      <span class="nickName">{{ nickname }}</span>
      <span @click.stop="loginOut()">{{ $t("loginOut") }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { getToken } from '@/utils/auth' // getToken from cookie
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["loginForm", "nickname","accessToken"]),
  },
  mounted() {
    if (getToken()) {
      this.$store.dispatch("GetUserInfo");
    }
  },
  methods: {
    loginIn() {
      this.$store.dispatch("clickLogin", true);
    },
    loginOut() {
      this.$store.dispatch("loginOut");
    },
  },
};
</script>>
<style lang="scss" scoped>
.login {
  border: none;
  font-size: 16px;
  line-height: 80px;
  color: #f2f2f2;
  cursor: pointer;
  .nickName {
    cursor: auto;
    font-size: 16px;
    margin-right: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/inOut.vue